export function buildProductFactoryPath({
  productType,
  scopeType,
  scopeId,
  timeframe = 'FY2026-Q4',
  templateId,
  sourceAiRunId,
} = {}) {
  const params = new URLSearchParams({
    productType,
    scopeType,
    scopeId,
    templateId,
    timeframe,
  });
  // AC-W7 — carry the originating governed run id so a scan-prefilled draft can link back to it.
  if (sourceAiRunId) {
    params.set('sourceAiRunId', sourceAiRunId);
  }

  return `/products?${params.toString()}`;
}

export function buildEnhancementReportPath({
  scopeType = 'enterprise',
  scopeId = 'ENT-OWHA',
  timeframe = 'FY2026-Q4',
  templateId = 'TPL-REPORT-ENHANCEMENT-IMPLEMENTATION',
} = {}) {
  return buildProductFactoryPath({
    productType: 'enhancement_implementation_report',
    scopeType,
    scopeId,
    timeframe,
    templateId,
  });
}

export function buildExecutiveDeckPath({
  scopeType = 'enterprise',
  scopeId = 'ENT-OWHA',
  timeframe = 'FY2026-Q4',
  templateId = 'TPL-DECK-OWHA-DIRECTOR',
} = {}) {
  return buildProductFactoryPath({
    productType: 'executive_deck',
    scopeType,
    scopeId,
    timeframe,
    templateId,
  });
}

export function buildInformationPaperPath({
  scopeType = 'project',
  scopeId,
  timeframe = 'FY2026-Q4',
  templateId = 'TPL-DOC-INFORMATION-PAPER',
  sourceAiRunId,
} = {}) {
  return buildProductFactoryPath({
    productType: 'information_paper',
    scopeType,
    scopeId,
    timeframe,
    templateId,
    sourceAiRunId,
  });
}

export function buildMonthlyStatusReportPath({
  scopeType = 'project',
  scopeId,
  timeframe = 'FY2026-Q4',
  templateId = 'TPL-REPORT-MONTHLY-STATUS',
} = {}) {
  return buildProductFactoryPath({
    productType: 'monthly_status_report',
    scopeType,
    scopeId,
    timeframe,
    templateId,
  });
}

export function buildCloseoutPackagePath({
  scopeType = 'project',
  scopeId,
  timeframe = 'FY2026-Q4',
  templateId = 'TPL-PKG-PROJECT-CLOSEOUT',
} = {}) {
  return buildProductFactoryPath({
    productType: 'closeout_package',
    scopeType,
    scopeId,
    timeframe,
    templateId,
  });
}

export function buildFinalProjectReportPath({
  scopeType = 'project',
  scopeId,
  timeframe = 'FY2026-Q4',
  templateId = 'TPL-REPORT-FINAL-PROJECT',
} = {}) {
  return buildProductFactoryPath({
    productType: 'final_project_report',
    scopeType,
    scopeId,
    timeframe,
    templateId,
  });
}

export function buildUatFeedbackReportPath({
  scopeType = 'enterprise',
  scopeId = 'ENT-OWHA',
  timeframe = 'FY2026-Q4',
  templateId = 'TPL-REPORT-UAT-FEEDBACK',
} = {}) {
  return buildProductFactoryPath({
    productType: 'uat_feedback_report',
    scopeType,
    scopeId,
    timeframe,
    templateId,
  });
}
